export const blank = (value, fallback = '-') => {
  if (value === undefined || value === null || value === '') return fallback
  return value
}

export const firstValue = (...values) => values.find(value => value !== undefined && value !== null && value !== '')

export const readArray = (value) => {
  if (Array.isArray(value)) return value
  if (Array.isArray(value?.records)) return value.records
  if (Array.isArray(value?.list)) return value.list
  if (Array.isArray(value?.rows)) return value.rows
  if (Array.isArray(value?.data?.records)) return value.data.records
  if (Array.isArray(value?.data?.list)) return value.data.list
  if (Array.isArray(value?.data?.rows)) return value.data.rows
  return []
}

export const normalizePage = (value, fallback = { current: 1, size: 10 }) => {
  const data = value?.data && typeof value.data === 'object' ? value.data : value
  const records = readArray(data)
  const current = Number(firstValue(data?.current, data?.page, data?.pageNo, fallback.current, 1)) || 1
  const size = Number(firstValue(data?.size, data?.pageSize, fallback.size, 10)) || 10
  const total = Number(firstValue(data?.total, data?.totalCount, records.length, 0)) || 0
  const pages = Number(firstValue(data?.pages, data?.totalPages, Math.ceil(total / size) || 1)) || 1
  return { records, pagination: { current, size, total, pages } }
}

export const formatDateTime = (value) => {
  if (!value) return ''
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  const pad = number => String(number).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export const toDateTimePayload = (value) => {
  if (!value) return ''
  if (typeof value === 'string') return value
  return formatDateTime(value)
}

export const templateStatusText = status => ({
  DRAFT: '草稿',
  ENABLED: '启用',
  DISABLED: '停用'
}[status] || blank(status))

export const templateStatusClass = status => ({
  DRAFT: 'is-warning',
  ENABLED: 'is-success',
  DISABLED: 'is-neutral'
}[status] || 'is-neutral')

export const flowStatusText = status => ({
  CREATING: '创建中',
  SIGNING: '签署中',
  PARTIALLY_SIGNED: '部分签署',
  COMPLETED: '已完成',
  REJECTED: '已拒签',
  CANCELED: '已撤回',
  EXPIRED: '已过期',
  RELIEVED: '已解除',
  EXCEPTION: '异常',
  INVALID: '已失效',
  SYNC_FAILED: '同步失败'
}[status] || blank(status))

export const flowStatusClass = status => ({
  CREATING: 'is-info',
  SIGNING: 'is-info',
  PARTIALLY_SIGNED: 'is-warning',
  COMPLETED: 'is-success',
  REJECTED: 'is-danger',
  CANCELED: 'is-neutral',
  EXPIRED: 'is-warning',
  RELIEVED: 'is-neutral',
  EXCEPTION: 'is-danger',
  INVALID: 'is-neutral',
  SYNC_FAILED: 'is-danger'
}[status] || 'is-neutral')

export const partyStatusText = status => ({
  WAITING: '待签署',
  PENDING: '待处理',
  WAITPICKUP: '待领取',
  FILLPENDING: '待填写',
  FILLACCEPT: '填写完成',
  SIGNED: '已签署',
  ACCEPT: '已签署',
  FORWARDED: '已转交',
  FORWARD: '已转交',
  REJECTED: '已拒绝',
  CANCELED: '已撤回',
  EXPIRED: '已过期',
  RELIEVED: '已解除'
}[status] || blank(status))

export const archiveStatusText = status => ({
  NONE: '未归档',
  PENDING: '待归档',
  ARCHIVING: '归档中',
  SUCCESS: '已归档',
  FAILED: '归档失败'
}[status] || blank(status))

export const processStatusText = status => ({
  PENDING: '待处理',
  SUCCESS: '成功',
  FAILED: '失败',
  IGNORED: '已忽略'
}[status] || blank(status))

export const statusClassByResult = status => {
  if (['SUCCESS', 'COMPLETED', 'SIGNED', 'ACCEPT', 'ENABLED'].includes(status)) return 'is-success'
  if (['FAILED', 'EXCEPTION', 'REJECTED'].includes(status)) return 'is-danger'
  if (['PENDING', 'SIGNING', 'PARTIALLY_SIGNED', 'ARCHIVING'].includes(status)) return 'is-warning'
  if (['CREATING'].includes(status)) return 'is-info'
  return 'is-neutral'
}

export const safeJson = (value) => {
  if (!value) return ''
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch (error) {
    return String(value)
  }
}
